import { ProfileModel } from "../../../models/Profile.model";

export const USER_LOADING = "USER_LOADING";
export const USER_FAILED = "USER_FAILED";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_WALLET_SUCCESS = "USER_WALLET_SUCCESS";
export const USER_SET_TOTAL_ASSET = "USER_SET_TOTAL_ASSET";
export const RESET_USER = "RESET_USER";

export interface UserLoading {
  type: typeof USER_LOADING;
}

export interface UserFail {
  type: typeof USER_FAILED;
}

export interface UserSuccess {
  type: typeof USER_SUCCESS;
  payload: {
    user: ProfileModel;
  };
}

export interface UserWalletSuccess {
  type: typeof USER_WALLET_SUCCESS;
  payload: {
    wallet: any;
  };
}

export interface UserSetTotalAsset {
  type: typeof USER_SET_TOTAL_ASSET;
  payload: {
    totalAsset: number;
  };
}

export interface ResetUser {
  type: typeof RESET_USER;
}

export type UserDispatchTypes =
  | UserLoading
  | UserSuccess
  | UserFail
  | UserWalletSuccess
  | UserSetTotalAsset
  | ResetUser
